import { useSelector } from "react-redux";
import { useState } from "react";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportCountyReportDataQuery, useSearchCountyReportApiQuery } from "../report";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { useLazyGetAllCustomerByTenantQuery } from "../../../customer/customerApi";
import ReportType from "./ReportType";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import { getCurrentMonthStartDate } from "../../../../helpers/utils/Utils";


const CountyReport = () => {


    const [type, setType] = useState('COUNTY_REPORT');
    const [triggerExportReportDataQuery] = useLazyExportCountyReportDataQuery();
    const getAllTenantApi = useGetAllTenantsQuery("");
    const [countDataApi, countDataApiResult] = useLazyGetAllCountyByStateAbbrQuery();
    const stateDataApi = useGetAllStatesQuery("");
    const [getAllCustomerTenantApi, getAllCustomerTenantApiResponse] = useLazyGetAllCustomerByTenantQuery();
    const formattedStartDate = getCurrentMonthStartDate();

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "County Report", url: "" }]
    )


    const columns: DataTableColumn[] = [
        {
            label: "Id",
            accessor: "id",
            overrideSortColumn: "id",
            visibility: { hasShowSetting: false, canColumnShow: false },
            canSort: true,
            filterOptions: [{
                dependentColumns: ["Product"],
                filterComponent: SearchSelectWithList(getAllTenantApi?.data, "name", "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
                overrideFilterLabel: "Tenant",
            }],
        },
        {
            label: "Product",
            accessor: "product",
            overrideSortColumn: "product",
            canSort: false,
            cell: (props: any) => {
                return <span>{props.value}</span>
            },
            filterOptions: [{
                dependentColumns: ["Customer"],
                filterComponent: SearchSelectWithList(getAllCustomerTenantApiResponse?.data, (customer: { customerName: any; customerNumber: any; }) => `${customer.customerName} (${customer.customerNumber})`, "id", "Select Customer(s)...", true, "customerIds"),
                onDependencyUpdated: (value: any) => {
                    getAllCustomerTenantApi({ tenantName: value });
                },
                overrideFilterLabel: "Customer(s)",
                overrideFilterAccessor: "customerIds",
            }],
        },

        {
            label: "State", accessor: "state", canSort: false, filterOptions: [{
                dependentColumns: ["Customer"],
                filterComponent: SearchSelectWithList(stateDataApi?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
            }],
            visibility: { hasShowSetting: true }
        },

        {
            label: "County",
            accessor: "customer",
            overrideSortColumn: "customer_id",
            visibility: { hasShowSetting: false },
            canSort: false,
            cell: (props: any) => {
                return <span>{props.row.original?.county}</span>;
            },
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },


        {
            label: "Customer",
            accessor: "county",
            canSort: false,
            visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <span>{props.row.original?.customer ? props.row.original?.customer : "N/A"}</span>;
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(countDataApiResult?.data, "countyName", "id", "Select County...", true, "counties"),
                onDependencyUpdated: (value: any) => {
                    countDataApi(value);
                },
                overrideFilterAccessor: "counties",
                overrideFilterLabel: "Counties",
            }]
        },
        {
            label: "Count", accessor: "count", overrideSortColumn: "reorder_number", canSort: false
        },
    ];

    const customFilter = {
        createdDateFrom: formattedStartDate,
        state: "TX"
    }

    return (
        <>
            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchCountyReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }}
                    defaultFilter={
                        {
                            ...customFilter,
                            "sortOrder": "ASCENDING",
                            "pageNumber": 0,
                            "pageSize": "15",
                            "sort": "creationDate"
                        }
                    }
                    userSettingGroup={"Report County"}
                    basePermission={"CTYREPO"}
                />
            </div>
            <div />
        </>
    )
}

export default CountyReport;